import { Component, OnInit } from '@angular/core';
import { BarraGovernoService } from '../../services/barra-governo.service';

@Component({
  selector: 'app-barra-governo',
  templateUrl: './barra-governo.component.html',
  styleUrls: ['./barra-governo.component.scss']
})
export class BarraGovernoComponent implements OnInit {

  barraGoverno: any;

  constructor(
    private barraGovernoService: BarraGovernoService
  ) { }

  async ngOnInit() {
    this.barraGoverno = await this.barraGovernoService.getBarraGoverno();
    const arraySplit = this.barraGoverno.imagem.url.split('http://');
    if (arraySplit.length > 1) {
      this.barraGoverno.imagem.url = 'https://' + arraySplit[1];
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/barra-governo/barra-governo.component.ts